import { baseURL } from "../../util/Constant";

//Update Designer
export const putUpdateKeeper = (id, number, line) => (dispatch) => {
  
   fetch(`${baseURL}/keeper/put`, {
     method: "PUT",
     headers: {
       "Content-Type": "application/json",
     },
     body: JSON.stringify({ id, number, line}),
   })
     .then((res) => res.json())
     .then((data) => {
       
     })
     .catch((error) => {
       console.log(error);
     });
 };